import styled from 'styled-components';

export const PriceText = styled.div`
  font-weight: 600;
  text-align: left;
  line-height: normal;
  margin: 0px;
  color: ${({ theme }) => theme.grey.darker};
  font-size: ${({ $isFloating }) => (!$isFloating ? '30px' : '24px')};
`;
